// src/services/api/offlineSales/returnNotes.js
// Note: the backend mounts this resource at /offline-sales/return-notes
// (see rettzy-backend/src/modules/offlineSales/routes/index.js), not /offline-sales/returns.
import { apiClient } from '../base';

// KNOWN GAP (as of this writing): rettzy-backend/src/modules/offlineSales/routes/returnNote.routes.js
// only defines POST / and GET /:id — there is no GET / (list) route yet. This call will 404 until
// the backend adds one. Kept here (rather than omitted) so ReturnNoteListPage has a real function
// to call and the list page's empty/error state can surface the gap instead of the page not existing.
export const getReturnNotes = async (params = {}) => {
  const response = await apiClient.get('/offline-sales/return-notes', { params });
  return response.data;
};

export const createReturnNote = async (data) => {
  const response = await apiClient.post('/offline-sales/return-notes', data);
  return response.data;
};

export const getReturnNote = async (returnId) => {
  const response = await apiClient.get(`/offline-sales/return-notes/${returnId}`);
  return response.data;
};

export const voidReturnNote = async (returnId, data) => {
  const response = await apiClient.put(`/offline-sales/return-notes/${returnId}/void`, data);
  return response.data;
};
